module.exports = __webpack_public_path__ + "static/ID-a59029bb96f7705077daffd6d1834959.svg";